import { BRAND } from "@/lib/brand";
import { ArrowRight, BookOpen } from "lucide-react";
import CompassO from "@/components/site/CompassO";

export default function Hero() {
  return (
    <section data-testid="hero-section" className="relative overflow-hidden">
      <div className="pointer-events-none absolute -top-40 -right-40 w-[700px] h-[700px] rounded-full"
           style={{ background: "radial-gradient(closest-side, rgba(200,16,46,0.42), transparent 70%)" }} />
      <div className="pointer-events-none absolute -bottom-32 -left-40 w-[500px] h-[500px] rounded-full"
           style={{ background: "radial-gradient(closest-side, rgba(212,175,55,0.16), transparent 70%)" }} />
      <div className="pointer-events-none absolute inset-0 grain" />

      <div className="relative px-6 md:px-12 lg:px-20 pt-16 pb-24 md:pt-24 md:pb-32 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-12 h-px bg-[color:var(--gold-500)]" />
            <span className="eyebrow">A Man&apos;s Transformation Movement</span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display font-black uppercase tracking-tighter leading-[0.86] text-[64px] sm:text-[88px] md:text-[112px] lg:text-[128px]"
          >
            <span className="block text-white">The</span>
            <span className="block text-white">Way</span>
            <span className="flex items-center gap-1 sm:gap-2" style={{ color: "var(--gold-500)" }}>
              <span>F</span>
              <CompassO size={96} />
              <span>rward</span>
            </span>
          </h1>

          <p className="mt-8 max-w-xl text-lg md:text-xl text-[color:var(--text-secondary)] leading-relaxed">
            Health. Wealth. Wellness. A premium men&apos;s transformation guide — and a real human support
            system — built by <span className="text-[color:var(--text-primary)]">Joel M. Alexander</span>.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a data-testid="hero-cta-client" href="#signup" className="btn-gold inline-flex items-center justify-center gap-3">
              Client Intake <ArrowRight size={16} />
            </a>
            <a data-testid="hero-cta-careers" href="#signup" className="btn-outline-gold inline-flex items-center justify-center gap-3">
              Apply to Work With Us <ArrowRight size={16} />
            </a>
          </div>

          <div className="mt-12 inline-flex items-center gap-4 px-5 py-4 border border-[color:var(--border-gold)] bg-[color:var(--navy-900)]/70">
            <BookOpen className="text-[color:var(--gold-500)]" size={22} />
            <div>
              <div className="eyebrow">Book Release</div>
              <div className="font-display uppercase tracking-tight text-lg md:text-xl text-white">
                {BRAND.bookReleaseLabel}
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div
            className="relative aspect-[3/4] overflow-hidden border border-[color:var(--border-gold)] bg-[color:var(--navy-800)]"
            data-testid="hero-portrait"
          >
            <img
              src="/generated/joel_photo.png"
              alt="Joel M. Alexander walking toward the sunrise, pointing the way forward"
              className="absolute inset-0 w-full h-full object-cover"
              style={{ objectPosition: "center center" }}
              data-testid="hero-joel-photo"
            />

            {/* Bottom gradient + caption */}
            <div
              className="absolute inset-0 pointer-events-none"
              style={{ background: "linear-gradient(180deg, rgba(4,10,24,0) 55%, rgba(4,10,24,0.96) 100%)" }}
            />
            <div className="absolute bottom-0 left-0 p-6 md:p-8">
              <div className="eyebrow mb-2">Founder &amp; Author</div>
              <div className="font-display font-bold uppercase text-3xl md:text-4xl leading-none tracking-tight">
                Joel M. Alexander
              </div>
              <div className="mt-2 text-sm text-[color:var(--text-secondary)]">
                {BRAND.title}
              </div>
            </div>
          </div>
          <div className="hidden lg:block absolute -bottom-6 -left-6 w-40 h-40 border border-[color:var(--gold-500)]" />
        </div>
      </div>
    </section>
  );
}
